import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DownloadItem from "./DownloadItem";
import Filter from "./Filter";
import useDownloads from "./useDownloads";
import { _project } from "state/store.projects";
import { getProjectData } from "state/jotai.projectDataHooks";
import { getFocus, useGet } from "state/jotai";
import { active_project } from "state/store.global";
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { useTranslation } from "react-i18next";
import { useBreak } from "hooks/useBreak";
import { ReactSelect } from "components/AdvanceDropdown/NormalDropdown/Dropdown";
import { _bootstrap } from "state/store.bootstrap";

function Downloads() {
  const [property, setProperty] = useState({})
  const { i18n:{language} }           = useTranslation()
  const data = getFocus(_project, "downloads");
 
  const isDesktop    = useBreak('md_up')

  const { pin, pid } = useGet(active_project);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];

  const dropdownOption = getFocus(_bootstrap, "projectnames");
  const type                          = useGet(_bootstrap).type


  // eslint-disable-next-line no-unused-vars
  const [filteredData, setFilteredData] = useState(data);

  const handleFilter = (pin, pid) => {
    if(Object.keys(data || {}).length) {
    setFilteredData(data?.[pin]?.[pid]);
    }
  };

  // filtering out duplicate downloads
   const filterData = property?.dpin === 0 ? filteredData?.filter((item, index, self) => index === self.findIndex((t) => t.url === item.url))?.slice(1) : filteredData

   useEffect(()=> {
     if(type === 'poly' && Object.keys(dropdownOption || {}).length) {
      const prp =  dropdownOption[language]?.[0]
      const initalPrp = {
            value: prp?.URLSafe,
            label: prp?.Presentation,
            dpin: prp?.PIN, 
            dpid: prp?.PID, 
       
      }
      
      setProperty(initalPrp)
     }
   }, [dropdownOption, type])

   useEffect(()=> {
      if(type === 'poly' && Object.keys(property || {}).length) {
        handleFilter(property?.dpin, property?.dpid)
      }else {
        handleFilter(pin, pid)
      }
   }, [data, property?.dpin, property?.dpid])
  
  return (
    <Box
      sx={{
        // pt: { lg: "4.625rem", xs: "2.5rem" },
        lineHeight: 1.4,
      }}
    >
      <Box
        sx={{
          maxWidth: "528px",
          width: '100%',
          px: isDesktop ? '48px' : '16px',
          py: isDesktop ? '24px' : '16px'
        }}
      >
        <Typography
          component="h2"
          variant="h2"
          sx={{
            fontWeight: 700,
            fontSize: { lg: "1.375rem", xs: "1.125rem" },
            mb: '16px',
          }}
        >
          {
            buttonsLabel?.filter(
              (btn) => btn.UILabelProperty === "DownloadMateriale"
            )[0]?.Label
          }
        </Typography>
        <p>
          {
            buttonsLabel?.filter(
              (btn) => btn.UILabelProperty === "DownloadUndertekst"
            )[0]?.Label
          }
        </p>
      </Box>
      {
        type === 'poly' && Object.keys(dropdownOption || {}).length && <Box sx={{  px: isDesktop ? '48px' : '16px', py: isDesktop ? '24px': '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
    <div className="h4">Vælg ejendom</div>
     <ReactSelect  options={dropdownOption[language].map(({ Presentation, URLSafe, PID, PIN }) => ({
                        value: URLSafe,
                        label: Presentation,
                        dpin: PIN, 
                        dpid: PID, 
                        }))}
                        value={property}
                        onChange={(e) => {
                        setProperty(e);
                        handleFilter(e.dpin, e.dpid)
                        }} />
   </Box>
      }
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: {md:"calc(100vh - 308px)", xs:"calc(100vh - 342px)"},
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          {
            Boolean(filterData?.length) ?
            filterData?.map((item, i) => {
              if(item.property === 'Prisliste') return <></>
              return (
            <DownloadItem key={i} {...item} />
          )
            })
           :
             <DownloadItem Byline={language === 'da' ? 'Der er ingen dokumenter tilgængelige på denne ejendom endnu.' : 'There are no documents available for this property yet.'}  />
          }
        </Box>
        <PoweredBy />
      </Box>
    </Box>
  );
}

export default Downloads;
